import React from "react";

const Bash_Intro = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Intro</h2>
      <p><strong>What is Bash?</strong> Bash (Bourne Again SHell) is a Unix shell and command language. It's commonly used as the default shell on Linux and macOS.</p><p>It reads commands from the user or from scripts and runs them.</p>
    </div>
  );
};

export default Bash_Intro;
